import React, { Component } from 'react';
import './style.scss'
import Rooms from './Rooms';
import Quizs from './Quizs';
import Report from './Report';
import QuizAnswers from './QuizAnswers';

class StatisticReports extends Component {
  render() {
    return (
      <div> 
         <div className="qbm-content StatisticReports">
            <div className="qbm-accordion-panel">
              <Rooms />
              <Quizs />
            </div>
            
            <div className="question-container">
              <Report />
              <QuizAnswers />
            </div>
         </div>
      </div>
    );
  }
}

export default StatisticReports;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StatisticReports/index.jsx